import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { WishlistService } from '../../../services/raintree/Transmission/wishlist.service';
import { ApiResponse } from '../../../services/raintree/interfaces/api-response.interface';
import { ToastrService } from 'ngx-toastr';
import { WishlistSuccessDialogComponent } from '../../../print-monitor/wishlist-success-dialog/wishlist-success-dialog.component';
import { DpSuccessMessageComponent } from '../../../common-component/dp-success-message/dp-success-message.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { LoaderComponent } from '../../../common-component/loader/loader.component';

@Component({
  selector: 'add-wishlist-dialog',
  standalone: true,
  templateUrl: './add-wishlist-dialog.component.html',
  styleUrl: './add-wishlist-dialog.component.scss',
  imports: [
    MatDialogModule,
    ReactiveFormsModule,
    FormsModule,
    MatAutocompleteModule, LoaderComponent
  ],
})
export class AddWishlistDialogComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<AddWishlistDialogComponent>,
    private _wishlistService: WishlistService,
    private toaster: ToastrService,
    private dialog: MatDialog
  ) {
    if (this.data.record.pincode != '' && this.data.record.pincode) {
      this.pin.disable();
    }
  }
  isLoading: boolean = false
  wishlists: any = [];
  pincodeList: any = [];
  wishlistName = new FormControl('');
  pin = new FormControl('');
  bodyObj: any = {};
  ngOnInit(): void {
    console.log(this.data);
    if (this.data.record.pincode === 'Unknown') {
      this.bodyObj.pincode = 'Unknown';
      console.log(this.bodyObj.pincode);
    } else {
      this.bodyObj.pincode = this.data.record.pincode;
    }

    this.pincodeList = this.data.pin;
    this.pin.setValue(this.data.record.pincode || '');

    this.pin.valueChanges.subscribe((item: any) => {
      if (item && item.length > 0) {
        this.pincodeList = this.data.pin.filter((pincode: string) =>
          pincode.includes(item)
        );
      }
    });
  }
  restrictWishlistNameInput(event: KeyboardEvent): void {
    const input = event.key;
    const pattern = /^[A-Za-z0-9\-_()\s]+$/;
    if (!pattern.test(input)) {
      event.preventDefault();
    }
  }
  addWishlist() {

    if (this.wishlistName.valid) {
      if (this.data.type == 'fd' || this.data.type == 'centralizedFd') {
        let bodyObj = {
          title: this.wishlistName.value,
          active: 1,
          wishlist_flag: 1,
          listType: 'PHL',
        };
        if (bodyObj.title?.length == 0)
          this.toaster.error('Kindly add wishlist name');
        else {
          this.isLoading = true
          this._wishlistService.addWishlist(bodyObj).subscribe({
            next: (response: ApiResponse) => {
              if (!response.error) {
                this.dialog.open(DpSuccessMessageComponent, {
                  panelClass: 'common-pannel-dialog-container',
                  data: {
                    mainHeading: `New Wishlist '${this.wishlistName.value}' has been created successfully!`,
                    subHeading:
                      'You can access all wish-lists from the ‘My wishlist’ menu on the Find Details Page ',
                    buttonValue: 'Done',
                  },
                });
                this.dialogRef.close(true);
              }
              this.isLoading = false

            },
            error: (error) => {
              this.isLoading = false
              this.toaster.error(error);
            },
          });
        }
      } else if (
        this.data.type == 'Reach' ||
        this.data.type == 'centralizedReach'
      ) {
        let reqBody = { name: this.wishlistName.value };
        if (reqBody.name?.length == 0)
          this.toaster.error('Kindly add wishlist name');
        else {
          this.isLoading = true
          this._wishlistService.addReachWishlist(reqBody).subscribe({
            next: (response: ApiResponse) => {
              if (!response.error) {
                this.dialog.open(DpSuccessMessageComponent, {
                  panelClass: 'common-pannel-dialog-container',
                  data: {
                    mainHeading: `New Wishlist '${this.wishlistName.value}' has been created successfully!`,
                    subHeading:
                      'You can access all wish-lists from the ‘My wishlist’ menu on the Reach Defaulter page ',
                    buttonValue: 'Done',
                  },
                });
                this.isLoading = false
                this.dialogRef.close(true);
              }
            },
            error: (error) => {
              this.isLoading = false

              this.toaster.error(error);
            },
          });
        }
      } else if (this.data.type == 'pm' || this.data.type == 'centralizedPm') {
        this.bodyObj = {
          wishlistName: this.wishlistName.value?.trim(),
          pincode: this.bodyObj.pincode || this.pin.value,
          uiDistrict: this.data.record.district,
          uiState: this.data.record.state,
        };
        if (
          this.bodyObj.wishlistName?.length == 0 ||
          this.bodyObj.pincode?.length == 0
        )
          this.toaster.error('Kindly add wishlist name and pincode');
        else if (
          this.bodyObj.pincode?.length == 6 ||
          this.bodyObj.pincode.toLowerCase() === 'unknown'
        ) {
          this.isLoading = true
          this._wishlistService.createWishlist(this.bodyObj).subscribe({
            next: (response: ApiResponse) => {
              if (!response.error) {
                this.dialog.open(DpSuccessMessageComponent, {
                  panelClass: 'common-pannel-dialog-container',
                  data: {
                    mainHeading: `New Wishlist '${this.wishlistName.value}' has been created successfully!`,
                    subHeading:
                      'You can access all wish-lists from the ‘My wishlist’ menu on the Print and Monitor Page ',
                    buttonValue: 'Done',
                  },
                });
                let returnData = {
                  added: true,
                  pincode: this.pin.value,
                };
                this.isLoading = false
                this.dialogRef.close(returnData);
              }
            },
            error: (error) => {
              this.isLoading = false
              this.toaster.error(error);
            },
          });
        }

      }
    }
  }
}
